import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    padding: '50px 48px 32px',
  },
  textColor: {
    color: theme.palette.text.subtitle,
  },
  cursorDefault: {
    cursor: 'default',
  },
  invoiceStatus: {
    borderRadius: 2,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    height: 27,
    padding: '5px 10px',
  },
  PAID: {
    backgroundColor: theme.palette.statuses.paid,
  },
  QUOTE: {
    backgroundColor: theme.palette.statuses.quote,
  },
  UNPAID: {
    backgroundColor: theme.palette.statuses.unpaid,
  },
  PENDING: {
    backgroundColor: theme.palette.statuses.pending,
  },
  PARTIAL: {
    backgroundColor: theme.palette.statuses.partial,
  },
  OVERPAID: {
    backgroundColor: theme.palette.statuses.overpaid,
  },
  CANCELLED: {
    backgroundColor: theme.palette.statuses.cancelled,
  },
  UNPAIDINPROGRESS: {
    backgroundColor: theme.palette.statuses.unPaidInProgress,
  },
  invoiceCardContainer: {
    backgroundColor: '#F9F9F9',
    maxWidth: 250,
    padding: '16px 24px',
    width: '100%',
  },
  listItem: {
    width: '100%',
    padding: '0 4px 0 0',
    borderBottom: `1px solid ${theme.palette.dividers.primary}`,

    '&:last-child': {
      border: 0,
      '& .MuiListItemText-secondary': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      textAlign: 'right',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: '50px',
      wordBreak: 'break-all',
      textAlign: 'end',
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles };
